import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_BANNER = "GET_LIST_BANNER";
export const GET_DETAIL_BANNER = "GET_DETAIL_BANNER";
export const UPDATE_BANNER = "UPDATE_BANNER";
export const SAVE_BANNER = "SAVE_BANNER";
export const DELETE_BANNER = "DELETE_BANNER";
export const SET_LIST_BANNER = "SET_LIST_BANNER";
export const SET_DETAIL_BANNER = "SET_DETAIL_BANNER";


const state = {
    banner: [],
    bannerDetail: {}
};

const getters = {
    banner(state) {
        return state.banner;
    },
    bannerDetail(state) {
        return state.bannerDetail;
    },


};

const actions = {
    [GET_LIST_BANNER](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_BANNER}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_BANNER, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_BANNER](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_BANNER}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_BANNER, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_BANNER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_BANNER}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_BANNER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_BANNER}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_BANNER](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_BANNER}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_BANNER](state, data) {
        state.banner = data.data;
    },
    [SET_DETAIL_BANNER](state, data) {
        state.bannerDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};